import { Step } from "../../../types/Step";
import AllMedicalQuestionsEvaluator from "../../Steps/Medical/Compositions/AllMedicalQuestionsEvaluator";
import { INavigatorItemConfig } from "../Components/Navigator";
import NavigatorItemId from "../Types/NavigatorItemId";

const ScreeningNavigatorConfiguration: INavigatorItemConfig = {
  id: NavigatorItemId.Screening,
  label: "Screening",
  isDisabled: () => false,
  onClickStep: Step.qualify,
  lastStep: Step.medicalDiabetic
};

const SchedulingNavigatorConfiguration: INavigatorItemConfig = {
  isDisabled: ({ medicalForm }) =>
    !AllMedicalQuestionsEvaluator.isComplete(medicalForm) || AllMedicalQuestionsEvaluator.isNonCandidate(medicalForm),
  id: NavigatorItemId.Scheduling,
  label: "Scheduling",
  onClickStep: Step.centerSelection,
  lastStep: Step.scheduling
};

/** The default navigator configuration for the no-confirmation variant (books directly from scheduling). */
export const NoConfirmationDefaultNavigatorConfiguration: INavigatorItemConfig[] = [
  ScreeningNavigatorConfiguration,
  SchedulingNavigatorConfiguration
];

/** The navigator configuration for pre-qualified patients in the no-confirmation variant. */
export const NoConfirmationPreQualifiedPatientNavigatorConfiguration: INavigatorItemConfig[] = [
  SchedulingNavigatorConfiguration
];
